import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import { APP_URL } from '../../../config';

function* billingSubscriptionModify({ payload: { billingPeriod, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.billing.subscription.modify,
      data: {
        billing_period: billingPeriod,
        success_url: `${APP_URL}billing?tab=subscriptions`,
        cancel_url: `${APP_URL}billing?tab=subscriptions`
      }
    });

    onSuccess && onSuccess(data.result);
    yield put(actions.billingSubscriptionModifyDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.billingSubscriptionModifyFailed,
      handledErrors,
      endpoint: api.billing.subscription.modify.url
    });
  }
}

export const billingSubscriptionModifySaga = takeEvery(types.BILLING_SUBSCRIPTION_MODIFY_REQUEST, billingSubscriptionModify);
